import { combineReducers } from "redux"

import authentication from "./authentication-reducer"
import routes from "./routes-reducer"
import navbar from "./navbar-reducer"
import entities from "./entities/root-entity-reducer"
import paging from "./paging/root-paging-reducer"
import presentation from "./presentation/root-presentation-reducer"
import { routerReducer } from "react-router-redux"
import alerts from "./alerts-reducer"

export default combineReducers({
    authentication,
    router: routerReducer,
    routes,
    navbar,
    entities,
    paging,
    presentation,
    alerts
})
